// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1L0W8","col":"styles_col__25s2_","fulfillmentStatus":"styles_fulfillmentStatus__1rk5J","emailCol":"styles_emailCol__5B0Lc"};